<!--
무자료 등록(재고방식) > 회원사 선택
------------------------------------
-->
<template>

    <div class="uk-flex uk-flex-column uk-flex-center uk-flex-middle uk-height-1-1">
        <div class="guide">
            <h2>
                <i class="material-icons">edit</i>
                <span class="uk-text-middle">무자료 기본정보 입력</span>
            </h2>
        </div>

        <div class="uk-background-default">
            <table class="input-table">

                <tr >
                    <th>
                        <i class="material-icons">
                            info
                        </i>
                        종류
                    </th>
                    <td>
                        <!-- 미국은 부분무자료만 허용 -->
                        <app-input-radio
                            v-if="regionCode !== 2"
                            class=""
                            :options="nameOptions"
                            v-model="box.name_prefix"
                        ></app-input-radio>

                        <div v-if="regionCode === 2">
                            {{ box.name_prefix }}
                        </div>
                    </td>
                </tr>

                <!-- 미국은 회원사 검색기능 제거 -->
                <tr v-if="regionCode !== 2">
                    <th class="highlight">
                        <i class="material-icons">
                            account_circle
                        </i>
                        회원사
                    </th>
                    <td class="highlight">
                        <app-input-search-select
                            class="uk-width-xlarge"
                            :options="regionMemberOptions"

                            v-model="box.user_id"
                            placeholder="무자료의 소유자를 선택하세요"
                        > </app-input-search-select>
                    </td>
                </tr>
                <tr v-if="regionCode === 2">
                    <th class="highlight">
                        <i class="material-icons">
                            account_circle
                        </i>
                        회원사
                    </th>
                    <td class="highlight">
                        {{ boxUserNick }}
                    </td>
                </tr>

                <tr >
                    <th>
                        <i class="material-icons">
                            local_shipping
                        </i>
                        트래킹번호
                    </th>
                    <td class="highlight">
                        {{ box.tracking_no }}
                    </td>
                </tr>
            </table>
        </div>

        <div class="uk-margin-top uk-text-center">
            <button
                type="button"
                class="uk-button uk-button-large uk-button-danger uk-margin-large-right"
                @click="cancel"
            >
                <i class="material-icons">close</i>
                취소
            </button>
            <button
                type="button"
                class="uk-button uk-button-large uk-button-primary"
                @click="done"
            >
                <i class="material-icons">check</i>
                저장
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        props: {
            // 지역ID
            regionId: Number,

            /**
             * 지역코드
             * (미국 커스텀때문에 추가됨)
             * 1 : 일본
             * 2 : 미국
             * 3 : 중국항공
             * 4 : 중국해상
             * 5 : 영국
             * 6 : 독일
             * 7 : 호주
             **/
            regionCode: {
                type: Number,
                default: null,
            },

            /**
             * (object) 박스정보
             * {
             *     tracking_no,
             *     user_id,
             *     name_prefix,
             * }
             */
            box: {
                type: Object,
            },

            /**
             * 지역 회원사옵션 배열
             */
            regionMemberOptions: {
                type: Array,
            },

            /**
             * 박스정보의 회원사 닉네임
             */
            boxUserNick: {
                type: String,
            },
        },
        data: function () {
            return {
                // 상품명 옵션배열
                nameOptions: [
                    {text: '무자료(전체)', val: '무자료(전체)'},
                    {text: '무자료(부분)', val: '무자료(부분)'},
                ],
            };
        },
        computed: {

        },
        methods: {
            /**
             * 취소처리
             */
            cancel() {
                // 이벤트 발생
                this.$emit('cancel');
            },

            /**
             * 완료처리
             */
            done() {
                // 회원사 검증
                if (! this.box.user_id) {
                    alert('회원사를 선택하세요!')
                    return;
                }

                // 이벤트 발생
                this.$emit('done');
            },
        },


    }
</script>

<style lang="scss" scoped>
    .guide {

        h2 {
            text-align: center;
            font-size: 1.25rem;
            color: #000;

            .material-icons {
                font-size: 1.5rem;
            }
        }
    }

    // 테이블
    .input-table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        th, td {
            text-align: left;
            border: 1px solid #cfcfcf;
            font-weight: normal;

            padding: 1rem;
            color: #000;
        }

        th {

            font-size: 1rem;
            background-color: #fefefe;
            width: 12rem;

            .material-icons {
                vertical-align: middle;
                font-size: 1.5rem;
                color: #aaa;
            }

            &.highlight .material-icons{
                color: #1e87f0 !important;
            }

        }
        td {
            text-align: center;
            font-size: 1rem;
            color: #000;
            //width: 25rem;

            &.highlight {
                //background-color: #ffffdd;

                &.amount {
                    font-size: 1.5rem;
                    color: #1e87f0 !important;
                    font-weight: bold;

                }
            }
        }

    }
</style>